import { getActivationId } from '@helpcenter/meta';
// eslint-disable-next-line no-restricted-imports
import { HelpPageAri } from '@atlassian/ari';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import EditCustomPageQuery from '../../../../help-center/custom-pages/src/ui/edit-custom-page/__generated__/editCustomPageQuery.graphql';
import type { editCustomPageQuery } from '../../../../help-center/custom-pages/src/ui/edit-custom-page/__generated__/editCustomPageQuery.graphql';

export const EditCustomPageResource = createRelayResource<editCustomPageQuery>({
    type: 'EDIT_CUSTOM_PAGE',
    getQuery: ({ match }, { cloudId, helpCenterAri }) => {
        const pageId = match.params.id;
        if (!pageId) {
            throw Error('No page id for custom page.');
        }
        const helpCenterPageAri: string = HelpPageAri.create({
            pageId,
            activationId: getActivationId(),
        }).toString();
        return {
            parameters: EditCustomPageQuery,
            variables: {
                cloudId,
                helpCenterAri,
                helpCenterPageAri,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
